import { Box, Button, Stack, Heading, LightMode, SimpleGrid, Text } from '@chakra-ui/react'

export const Hero = () => {
  return (
    <Box
      as="section"
    //   bg="gray.800"
      py="12"
      position="relative"
      h={{ base: '500px', md: '570px' }}
      bgImage="/Hero E.png"
      bgSize="cover"
      bgPosition="center"
      _after={{
        content: `""`,
        display: 'block',
        w: 'full',
        h: 'full',
        // bg: 'blackAlpha.700',
        position: 'absolute',
        inset: 0,
        zIndex: 0,
      }}
    >
      <Box
        maxW={{ base: 'xl', md: '7xl' }}
        mx="auto"
        px={{ base: '6', md: '8' }}
        h="full"
        zIndex={1}
        position="relative"
      >
        <Stack flexDirection="column" textAlign="left" color="white" h="full" pl={'5%'}pr={'5%'}>
          <Heading fontFamily={'montserrat, sans-serif'} size={["l", "xl", "xl"]} fontWeight="extrabold" pt={["25%", "25%", "25%"]}>
          About
          </Heading>
          <Heading fontFamily={'montserrat, sans-serif'} fontSize={["16px", "25px", "27px"]} fontWeight={"200"} pt={'2%'} lineHeight={['30px','35px','40px']}>
          The Shin-Zylstra team mission is to expand the notoriety of Utah's Multifamily 
          Real Estate market by contributing world-class service and sharing market-leading 
          expertise with clients, partners, and strategic connections.
          </Heading>
        </Stack>
      </Box>
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        zIndex={2}
        w="full"
        bottom="0"
        py="4"
        
      >
      </Box>
    </Box>
  )
}